
export default class LetterSplitter {
  constructor() {}

  splitElementText(el, options) {

    let fontSize = options.fontSize || 14;

    let text = el.innerText;
    el.innerText = "";
    let letters = text.split("");
    let spanArray = [];
    letters.forEach((letter, i) => {
      let span = document.createElement('span');
      span.innerText = letter;
      span.style.position = "absolute";
      span.style.opacity = 0;
      let x = (i * fontSize) - (fontSize * (letters.length) * .5);
      let y = 0;
      span.style.transform = "translate(" + x + "px," + y + "px)";
      el.appendChild(span);
      spanArray.push(span);
    });

    return spanArray;
  }
}
